import React, { FunctionComponent } from 'react';
import { BlockTypes, InstantBlock } from '../../types/api/Block';
import { BlockContextProvider } from './BlockContext';
import { ErrorBoundary } from '../components/ErrorBoundary/ErrorBoundary';

export function asBlock<Embedded, BlockType extends BlockTypes>(
  Component: FunctionComponent<Embedded>,
  _?: BlockType
): FunctionComponent<InstantBlock<Embedded, BlockType>> {
  function ComponentAsBlock({ embedded, ...props }: InstantBlock<Embedded, BlockType>) {
    return (
      <ErrorBoundary key={`error-boundary-${props.uuid}`}>
        <BlockContextProvider
          uuid={props.uuid}
          elementType={props.elementType}
          fetchUrl={props.fetchUrl}
          blockLayout={props.blockLayout}
        >
          <Component {...embedded} key={props.uuid} />
        </BlockContextProvider>
      </ErrorBoundary>
    );
  }

  return ComponentAsBlock;
}
